bcl.s.form.formsToggle = {
  props: {
    classButtonToggle: "forms-toggle-JS",
    dataAttributeToggle: "toggleClass",
    dataAttributeToggleHidden: "toggleClassHidden",
    dataAttributeToggleSkipFirst: "toggleSkipFirst",
    classHidden: "hidden",
    classNotHidden: "notHidden",
  },

  init: function ($input, $form) {
    if (($input.type === "radio" || $input.tagName.toLowerCase() === "select") && bcl.u.containsClass($input, bcl.s.form.formsToggle.props.classButtonToggle)) {
      bcl.s.form.formsToggle.toggle($input, $form);
      bcl.u.forEach(document.getElementsByName($input.name), function ($item) {
        $item.addEventListener("change", function () {
          bcl.s.form.formsToggle.toggle($input, $form);
          if ($form?.querySelector(".help-forms-submit-js")) {
            $form.dispatchEvent(new Event("input", { bubbles: true }));
          }
        });
      });
    }
  },

  selectSelected: function ($input) {
    let value = null;

    if ($input && $input.selectedIndex) {
      const dataAttr = $input.options[$input.selectedIndex].dataset[bcl.s.form.formsToggle.props.dataAttributeToggle];

      if (dataAttr) {
        value = dataAttr;
      }
    }

    return value;
  },

  toggle: function ($input, $form) {
    let skipFirst = false;

    if ($input.dataset[bcl.s.form.formsToggle.props.dataAttributeToggleSkipFirst] !== undefined) {
      skipFirst = true;
    }

    const dataSelectorHidden = $input.dataset[bcl.s.form.formsToggle.props.dataAttributeToggleHidden];

    if (dataSelectorHidden) {
      const dataSelectorsHidden = dataSelectorHidden.split(",");

      bcl.u.forEach(dataSelectorsHidden, function (selector) {
        bcl.u.forEach($form.getElementsByClassName(selector), function ($element) {
          if (!bcl.u.containsClass($element, bcl.s.form.formsToggle.props.classNotHidden)) {
            bcl.s.form.changeClassValidateInput($element, $form);
            bcl.u.addClass($element, bcl.s.form.formsToggle.props.classHidden);
          }

          if (!skipFirst) {
            $element.removeAttribute("required");
            bcl.u.forEach($element.labels, function ($elementLabel) {
              bcl.u.removeClass($elementLabel, "required");
            });
          }

          if (!skipFirst && $element.tagName.toLowerCase() === "span") {
            bcl.u.removeClass($element, "required");
          }
        });

        //Resset hidden selects
        bcl.u.forEach($form.querySelectorAll("select"), function ($select) {
          if (bcl.u.containsClass($select, bcl.s.form.formsToggle.props.classHidden) || bcl.u.containsClass($select.parentElement, bcl.s.form.formsToggle.props.classHidden)) {
            $select.firstElementChild.selected = "selected";
          }
        });
      });
    }

    let dataSelector = $input.dataset[bcl.s.form.formsToggle.props.dataAttributeToggle];

    if ($input.tagName.toLowerCase() === "select") {
      dataSelector = bcl.s.form.formsToggle.selectSelected($input);
    }
    if (dataSelector != null) {
      bcl.u.forEach($form.getElementsByClassName(dataSelector), function ($it) {
        if (($input.type === "radio" && $input.checked) || ($input.tagName.toLowerCase() === "select" && $input.options[$input.selectedIndex].dataset[bcl.s.form.formsToggle.props.dataAttributeToggle] === dataSelector)) {
          if (!bcl.u.containsClass($it, bcl.s.form.formsToggle.props.classNotHidden)) {
            bcl.u.removeClass($it, bcl.s.form.formsToggle.props.classHidden);
          }

          if (!skipFirst && ($it.tagName.toLowerCase() === "select" || $it.type === "text" || $it.type === "file")) {
            $it.setAttribute("required", "");
            bcl.u.forEach($it.labels, function ($itLabel) {
              bcl.u.addClass($itLabel, "required");
            });
          }

          if (!skipFirst && $it.tagName.toLowerCase() === "span") {
            bcl.u.addClass($it, "required");
          }

          bcl.s.form.formsToggle.toggle($it, $form);
        } else if (!skipFirst) {
          if (!bcl.u.containsClass($it, bcl.s.form.formsToggle.props.classNotHidden)) {
            bcl.s.form.changeClassValidateInput($it, $form);
            bcl.u.addClass($it, bcl.s.form.formsToggle.props.classHidden);
          }

          $it.removeAttribute("required");

          bcl.u.forEach($it.labels, function ($itLabel) {
            bcl.u.removeClass($itLabel, "required");
          });
        }
      });
    }

    if (skipFirst) {
      $input.removeAttribute("data-toggle-skip-first");
    }
  },
};
